// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/hydrant-schema',
  type: 'object',
  required: ['id', 'creatorId', 'fireDepartmentId', 'number', 'address', 'location', 'adapter75Count', 'adapter55Count', 'lat', 'lng'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    fireDepartmentId: {
      type: 'integer',
    },
    number: {
      type: 'integer',
    },
    address: {
      type: 'string',
      minLength: 1,
    },
    location: {
      type: 'string',
      minLength: 1,
    },
    adapter75Count: {
      type: 'integer',
    },
    adapter55Count: {
      type: 'integer',
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    lat: {
      type: 'number',
    },
    lng: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
